import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useEmailTemplates() {
  return useQuery(
    orpc.communications.emailTemplates.list.queryOptions({ input: {} }),
  );
}

export function useEmailTemplateBuiltins() {
  return useQuery(
    orpc.communications.emailTemplates.builtins.queryOptions({ input: {} }),
  );
}

export function useCreateEmailTemplateFromBuiltin() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.createFromBuiltin.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.list.key(),
        });
      },
    }),
  );
}

export function useCreateEmailTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.list.key(),
        });
      },
    }),
  );
}

export function useUpdateEmailTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.list.key(),
        });
      },
    }),
  );
}

export function useRenderPreview() {
  return useMutation(
    orpc.communications.emailTemplates.renderPreview.mutationOptions(),
  );
}

export function useDeleteEmailTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.list.key(),
        });
      },
    }),
  );
}

export function useEmailTemplateVersions(emailTemplateId: string) {
  return useQuery({
    ...orpc.communications.emailTemplates.listVersions.queryOptions({
      input: {
        emailTemplateId:
          emailTemplateId || '00000000-0000-0000-0000-000000000000',
      },
    }),
    enabled: !!emailTemplateId,
  });
}

export function useCreateEmailTemplateDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.createDraft.mutationOptions({
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.listVersions.key({
            input: { emailTemplateId: variables.emailTemplateId },
          }),
        });
      },
    }),
  );
}

export function useUpdateEmailTemplateDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.updateDraft.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.listVersions.key(),
        });
      },
    }),
  );
}

export function useFinalizeEmailTemplateDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.finalizeDraft.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.listVersions.key(),
        });
      },
    }),
  );
}

export function usePublishEmailTemplateVersion() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.emailTemplates.publishVersion.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.list.key(),
        });
        queryClient.invalidateQueries({
          queryKey: orpc.communications.emailTemplates.listVersions.key(),
        });
      },
    }),
  );
}
